var map = {
	"./deco.gif": 547,
	"./dish.webp": 927,
	"./jajang.mp4": 355,
	"./jajang.webp": 228,
	"./jjambbong.webp": 333,
	"./korean.webp": 831,
	"./skills/dish.webp": 622,
	"./tongfei.png": 901
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 825;
module.exports = webpackAsyncContext;